import { showWarningMessage } from '../../../_component/MessageSnack';
import axiosInstance from '../../../_config/AxiosInstance';
import config from '../../../_config/config';
import { categoryConstants } from '../../constant';

export const fetch_categories_action = () => async (dispatch) => {
  dispatch({
    type: categoryConstants.FETCH_CATEGORIES_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.category.category);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: categoryConstants.FETCH_CATEGORIES_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: categoryConstants.FETCH_CATEGORIES_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};

export const create_category_action = (data) => async (dispatch) => {
  dispatch({
    type: categoryConstants.CREATE_CATEGORY_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(`${config.category.category}`, data);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: categoryConstants.CREATE_CATEGORY_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: categoryConstants.CREATE_CATEGORY_ACTION_FAILURE,
      payload: e?.error,
    });
    showWarningMessage(e.error || e.message);
  }
};
